export default __webpack_public_path__ + "static/media/rm1.18349920.png";